import { useContext, useMemo } from "react";
import CartSelectionChoice from "./cart-selection-choice";
import CartSelectionSummary from "./cart-selection-summary";
import CartContext from "../../context/cart";
import classNames from "classnames";
import Translate from "../translate";
import CartSummary from "./cart-summary";

const CartSelectionPhase = ({
  cartRequestMutation,
  handleCartSelection,
  tempCartId,
  setTempCartId,
}) => {
  const { survey, currentSectionIndex, labels } = useContext(CartContext);

  const section = useMemo(
    () => survey?.definition?.sections?.[currentSectionIndex],
    [survey, currentSectionIndex]
  );

  return (
    <div
      className={classNames(
        "wrapper page-content",
        [1, 2].includes(currentSectionIndex) && "wrapper-small"
      )}
    >
      <span className="app-content__step">
        {labels?.WELFARE_STEP || "Step"} {currentSectionIndex + 1}
      </span>
      <h2 className="carrello-content__title">
        <Translate text={section?.label} />
      </h2>
      {section?.description && (
        <div className="carrello-content__text">
          <Translate html={section?.description} />
        </div>
      )}
      {
        {
          0: (
            <CartSelectionChoice
              cartRequestMutation={cartRequestMutation}
              handleCartSelection={handleCartSelection}
            />
          ),
          1: <CartSelectionSummary tempCartId={tempCartId} setTempCartId={setTempCartId} />,
          2: null,
        }[currentSectionIndex]
      }
      {[1, 2].includes(currentSectionIndex) && (
        <CartSummary
          variant={currentSectionIndex === 2 && "confirmation"}
          tempCartId={tempCartId}
        />
      )}
    </div>
  );
};

export default CartSelectionPhase;
